var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("screen-header", {
        attrs: { updateTime: _vm.updateTime },
        on: { "update-data": _vm.updateData }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "stage-basic" }, [
          _c("div", { staticClass: "stage-basic-title" }, [
            _c("img", {
              attrs: {
                src: require("../../assets/big-screen/city-basic-left.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "city-basic-title-font" }, [
              _vm._v(_vm._s(_vm.schoolName) + " 基本情况统计")
            ]),
            _vm._v(" "),
            _c("img", {
              attrs: {
                src: require("../../assets/big-screen/city-basic-right.png"),
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top-select" }, [
            _c("div", { staticClass: "stage-select" }, [
              _c(
                "div",
                { staticStyle: { "line-height": "18px" } },
                [
                  _c("span", [_vm._v("选择年级：")]),
                  _vm._v(" "),
                  _vm._l(_vm.grades, function(item) {
                    return _c(
                      "span",
                      {
                        key: item.value,
                        class:
                          _vm.grade === item.value
                            ? "school-stage active"
                            : "school-stage",
                        on: {
                          click: function($event) {
                            return _vm.changeGrade(item)
                          }
                        }
                      },
                      [_vm._v(_vm._s(item.name))]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stage-data" },
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", [_vm._v("班级(总数)")]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "margin-top": "10px" } }, [
                        _c("span", { staticClass: "data-font" }, [
                          _vm._v(_vm._s(_vm.pageData.totalClassCount || 0))
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("个")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", [_vm._v("班级(55人以上)")]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "margin-top": "10px" } }, [
                        _c("span", { staticClass: "special-data-font" }, [
                          _vm._v(_vm._s(_vm.pageData.largeClassCount || 0))
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("个")])
                      ])
                    ]),
                    _vm._v(" "),
                    !_vm.grade
                      ? _c("el-col", { attrs: { span: 4 } }, [
                          _c("span", [_vm._v("教师")]),
                          _vm._v(" "),
                          _c("p", { staticStyle: { "margin-top": "10px" } }, [
                            _c("span", { staticClass: "data-font" }, [
                              _vm._v(_vm._s(_vm.pageData.teacherCount || 0))
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("人")])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", [_vm._v("学生")]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "margin-top": "10px" } }, [
                        _c("span", { staticClass: "data-font" }, [
                          _vm._v(_vm._s(_vm.pageData.studentCount || 0))
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("人")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", [_vm._v("男生")]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "margin-top": "10px" } }, [
                        _c("span", { staticClass: "data-font" }, [
                          _vm._v(_vm._s(_vm.pageData.boyCount || 0))
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("人")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", [_vm._v("女生")]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "margin-top": "10px" } }, [
                        _c("span", { staticClass: "data-font" }, [
                          _vm._v(_vm._s(_vm.pageData.girlCount || 0))
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("人")])
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table" },
            [
              _c(
                "div",
                { staticClass: "analysis" },
                [
                  _c("span", { staticClass: "table-title" }, [
                    _vm._v("班级人员统计")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "analysis-select",
                      attrs: {
                        placeholder: "请选择",
                        size: "medium",
                        "popper-append-to-body": false
                      },
                      on: { change: _vm.changeGrade1 },
                      model: {
                        value: _vm.grade1,
                        callback: function($$v) {
                          _vm.grade1 = $$v
                        },
                        expression: "grade1"
                      }
                    },
                    _vm._l(_vm.tableOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "table-row scroll" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "home-table",
                          attrs: {
                            data: _vm.tableData,
                            size: "medium",
                            border: "",
                            "header-row-style": { color: "#fff" },
                            "row-style": { height: "40px" }
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "id", label: "序号", width: "120" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(scope.$index + 1) +
                                        "\n                "
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "className", label: "班级" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "studentNumber", label: "班级人数" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        class:
                                          Number(scope.row.studentNumber) > 55
                                            ? "red"
                                            : ""
                                      },
                                      [_vm._v(_vm._s(scope.row.studentNumber))]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "boyCount", label: "男生数" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "girlCount", label: "女生数" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-58ed76a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-58ed76a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/big-screen/SchoolAnalysis.vue
// module id = null
// module chunks = 